import React, { useState, useEffect } from 'react';
import { Row, Col, Modal, Button } from "react-bootstrap"
import { Page, SearchBar } from 'components';
import { Results } from './components';

import Header from '../../components/Header/Header';
import Reload from '../../components/Reload/Reload';
import ApiMServer from 'services/ApiMServer';
import { loadState, saveState } from 'utils/persistState';
import { useAppTheme } from '../../contexts/ThemeContext';

const ServerLocal = (props) => {

  const user = JSON.parse(localStorage.getItem('userData'));
  if (user?.permission?.equipments?.read !== true) {
    window.location.replace('/home');
  }

  const [servers, setServers] = useState([]);
  const [serversToShow, setServersToshow] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [searchData, setSearchData] = useState('');
  const [serverSerial, setServerSerial] = useState('');
  const [loading, setLoading] = useState(true);

  const STORAGE_KEY = 'filters:serverlocal';

  const currentTheme = useAppTheme();

  // Load persisted searchData on mount
  useEffect(() => {
    const persisted = loadState(STORAGE_KEY, null);
    if (persisted && typeof persisted.searchData === 'string') {
      setSearchData(persisted.searchData);
    }
  }, []);

  // Persist searchData on change
  useEffect(() => {
    saveState(STORAGE_KEY, { searchData });
  }, [searchData]);

  const handleClickOpen = (serial) => {
    setServerSerial(serial);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const getServers = async () => {
    setLoading(true);
    try {
      const { data } = await ApiMServer.get(`/api/v1/server-all`);
      const sortedData = data.sort((a, b) => a.serial.localeCompare(b.serial));
      setServers(sortedData);
      setServersToshow(sortedData);
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  const removeEquipment = async () => {
    try {
      setOpen(false);
      await ApiMServer.delete(`/api/v1/server-config/${serverSerial}`);
      getServers();
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getServers();
  }, [])

  // Auto-apply filter when data or search changes
  useEffect(() => {
    handleSearch();
  }, [servers, searchData]);

  const handleSearch = () => {
    if (!searchData.trim()) {
      setServersToshow(servers);
      return;
    }

    const usersSearch = servers.filter((user) =>
      ['serial', 'ip', 'company_id'].some(
        (key) =>
          user?.[key] &&
          user[key].toUpperCase().includes(searchData.toUpperCase())
      )
    );
    setServersToshow(usersSearch);
  };

  const handleSearchData = (e) => {
    setSearchData(e.target.value);
  };

  return (
    <Page className="p-3" title="Server Local">
      <Header page={'Server Local'} />

      {loading && <Reload />}

      <Row className="align-items-center g-2">
        <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
          <SearchBar
            onSearch={handleSearch}
            onSearchData={handleSearchData}
            searchData={searchData}
          />
        </Col>
      </Row>

      {serversToShow && (
        <Results
          user={user}
          data={serversToShow}
          currentTheme={currentTheme}
          onRemoveButton={handleClickOpen}
        />
      )}

      <Modal
        show={open}
        onHide={handleClose}
        contentClassName={currentTheme === 'dark' ? 'bg-dark text-light' : 'bg-light text-dark'}
      >
        <Modal.Header
          closeButton
          className={currentTheme === 'dark' ? 'bg-dark text-light border-secondary' : 'bg-light text-dark'}
        >
          <Modal.Title id="alert-dialog-title">Remover</Modal.Title>
        </Modal.Header>
        <Modal.Body className={currentTheme === 'dark' ? 'bg-dark text-light' : 'bg-light text-dark'}>
          Confirma Remover este Equipamento?
        </Modal.Body>
        <Modal.Footer className={currentTheme === 'dark' ? 'bg-dark text-light border-secondary' : 'bg-light text-dark'}>
          <Button variant="secondary" onClick={handleClose}>
            Não
          </Button>
          <Button variant="danger" onClick={removeEquipment}>
            Sim
          </Button>
        </Modal.Footer>
      </Modal>

    </Page >
  );
};

export default ServerLocal;
